module.exports = __webpack_public_path__ + "static/img/30002 (1).abd83cf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30002 (1).webp
// module id = UWMf
// module chunks = 14